import React from 'react';

import './index.less';
import SwipePlayer from './SwipePlayer.jsx'
export default () => {
    const imgList = [
        // {url : 'http://www.ciqa.org.cn/images/banner/banner11.png'},
        // {url : 'http://www.ciqa.org.cn/images/banner/banner12.png'},
        // {url : 'http://www.ciqa.org.cn/images/banner/banner13.png'},
        // {url : 'http://www.ciqa.org.cn/images/banner/banner14.png'},
        // {url : 'http://www.ciqa.org.cn/images/banner/banner15.png'},
        {url : 'http://47.112.249.63/images/banner/banner1.jpg'},
        {url : 'http://47.112.249.63/images/banner/banner2.jpg'},
        {url : 'http://47.112.249.63/images/banner/banner3.jpg'},
        {url : 'http://47.112.249.63/images/banner/banner4.jpg'},
        {url : 'http://47.112.249.63/images/banner/banner5.jpg'},
        {url : 'http://47.112.249.63/images/banner/banner6.jpg'},
        {url : 'http://47.112.249.63/images/banner/banner7.jpg'},
        {url : 'http://47.112.249.63/images/banner/banner8.jpg'},
        {url : 'http://47.112.249.63/images/banner/banner9.jpg'},
        {url : 'http://47.112.249.63/images/banner/banner10.jpg'}
    ]

    return (
        <div className="ciqa-banner">
            <SwipePlayer images={imgList}></SwipePlayer>
            {/* <ul>
                { 
                    (imgList||[]).map((item , i ) =>{
                        return <li>
                            <a href="/#/"><img src={item.url} ></img></a>
                        </li>
                    })
                } 
            </ul> */}
            {/* <ul>
                <li>
                    <a href="/#/"><img src="http://www.ciqa.org.cn/images/6b8f8f3cf92c8d22a84096218807963.png" ></img></a>
                </li>
                <li>
                    <a href="/#/"><img src="http://www.ciqa.org.cn/images/1684580d93be5bb6d69373f83edf61b.png" ></img></a>
                </li>
                <li>
                    <a href="/#/"><img src="http://www.ciqa.org.cn/images/b67c1e6000f41715cc6c29d6605dff9.png" ></img></a>
                </li>
            </ul> */}
            {/* <span className="handler">
                {
                    (imgList||[]).map((item , i ) =>{
                        return  <i></i>
                    })
                }
                <i></i>
                <i className="active"></i>
                <i></i>
            </span> */}
        </div>
    )
}